import { ShiftViewModel } from '../../models'

export default function filterShiftsByDepartments(
    shifts: ShiftViewModel[],
    departments: string[],
): ShiftViewModel[] {
    return shifts.filter(shift => !! departments
        .find(department => department === shift?.department?.id))
}
